import React from 'react';
import { useIntl } from 'react-intl';
import { Paper, Tooltip, Fab, Typography } from '@mui/material';
import { ColumnFlexBox, FullSizeCenteredFlexBox } from '../FlexBox';
import AddIcon from '@mui/icons-material/Add';
import useHasPermission from '../../Hooks/useHasPermission';

const CreditsPaper = function CreditsPaper({
  remainingSMS,
  handlePurchaseHistoryPage,
}) {
  const intl = useIntl();

  // The button goes to the purchase history, which is what the key it is bound to protects.
  const canPurchase = useHasPermission('purchases.viewhistory');

  return (
    <Paper
      sx={{
        padding: '6px 12px',
        width: canPurchase ? '180px' : 'auto',
        height: '100%',
      }}
    >
      <FullSizeCenteredFlexBox
        justifyContent={canPurchase ? 'space-between' : 'center'}
      >
        <ColumnFlexBox>
          <Typography variant="subtitle2" sx={{ textAlign: 'center' }}>
            {intl.messages.REMAINING_SMS_CREDITS}
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontSize: '24px',
              textAlign: 'center',
              color:
                remainingSMS > 500
                  ? 'success.main'
                  : remainingSMS > 100
                    ? 'warning.main'
                    : 'error.main',
            }}
          >
            {remainingSMS}
          </Typography>
        </ColumnFlexBox>

        {canPurchase && (
          <Tooltip title={intl.messages.PURCHASEHISTORY}>
            <Fab
              size="small"
              color="primary"
              onClick={() => {
                handlePurchaseHistoryPage();
              }}
            >
              <AddIcon />
            </Fab>
          </Tooltip>
        )}
      </FullSizeCenteredFlexBox>
    </Paper>
  );
};

export default CreditsPaper;
